import {
  Button, Checkbox,
  Form, Input,
  Modal,
  Spin,
} from 'antd';
import { bool, func, string } from 'prop-types';
import { useState, useEffect } from 'react';

import { CloseModalSVG } from 'components/iconsSVG/close';
import { SadFaceSVG } from 'components/iconsSVG/sadFace';
import {
  getMarket, getLang,
} from 'utils/helpers';
import { useI18n } from 'context/i18n';
import { PhoneInput } from 'components/base';
import { subscribeTwsEvent, unsubscribeTwsEvent, conditionsTwsEvent } from 'actions/general';
import { checkNewsletterStatus } from 'actions/users';
import { ThankYouMessage } from 'components/thankYouMessage';
import ProtectionDataModal from 'components/protectionDataModal';

import { IS_NNORMAL } from 'utils/constants';

import { useValidate } from 'hooks';
import styles from './style.module.css';

const EventsTwsModal = ({
  loading, modalTwsVisible, setModalTwsVisible, onFinishOk, id, type, email,
}) => {
  const {
    locale, t, profileData,
  } = useI18n();
  const validate = useValidate();
  const [ dataModalVisible, setDataModalVisible ] = useState(false);
  const [ isNewUser, setIsNewUser ] = useState(false);
  const [ currentEmail, setCurrentEmail ] = useState('');
  const [ currentTwsConditionsUrl, setCurrentTwsConditionsUrl ] = useState('#');
  const [ error, setError ] = useState(null);
  const [ loadingEmailRequest, setLoadingEmailRequest ] = useState(false);
  const [ showThankYou, setShowThankYou ] = useState(false);
  const [ thankYouType, setThankYouType ] = useState('eventSuscribedUserNew');
  const [ emailForm ] = Form.useForm();

  const market = getMarket(locale);
  const lang = getLang(locale);

  useEffect(() => {
    const getConditionsTwsEventHandler = async () => {
      if (modalTwsVisible) {
        try {
          const rsConditions = await conditionsTwsEvent({ eventId: id });
          let eventConditions = rsConditions.urlTc;
          if (eventConditions && eventConditions.includes('{lang}')) {
            eventConditions = eventConditions.replace('{lang}', lang?.toUpperCase());
          }
          if (eventConditions) {
            setCurrentTwsConditionsUrl(eventConditions);
          }
        } catch (e) {
          console.error(e);
        }
      }
    };

    getConditionsTwsEventHandler();
  }, [ modalTwsVisible ]);

  const onFinish = async (values) => {
    setLoadingEmailRequest(true);
    const payload = {
      eventId: Number(id),
      name: values.name || '',
      email: values.email,
      phone: '',
      profile: locale,
    };

    try {
      const newsletterRs = await checkNewsletterStatus(locale, values.email);
      if (!newsletterRs?.newsletterSubscribed && currentEmail !== values.email) {
        setCurrentEmail(values.email);
        setLoadingEmailRequest(false);
        setIsNewUser(true);
      } else {
        const result = await subscribeTwsEvent(payload);
        if (result) {
          const showJustAdded = true;
          const userIdientified = true;
          onFinishOk(showJustAdded, userIdientified);
        }
        setIsNewUser(false);
        setLoadingEmailRequest(false);
        setShowThankYou(true);
        if (result?.message === 'already') {
          setThankYouType('eventSuscribedAlready');
        } else if (result?.message === 'full') {
          setThankYouType('eventSuscribedFull');
        } else {
          setThankYouType(newsletterRs?.newsletterSubscribed ? 'eventSuscribedUserExists' : 'eventSuscribedUserNew');
        }
      }
    } catch (rqError) {
      console.error(rqError);
      let errorMessage = 'KO: Unexpected Error';
      if (rqError?.data?.errors?.length > 0) {
        errorMessage = rqError?.data?.errors[0].message || 'KO: Unexpected Error';
      }
      if (rqError?.data?.message === 'blocked') {
        errorMessage = t('generico', 'tws.blocked.event');
      }
      setError(errorMessage);
      setLoadingEmailRequest(false);
    }
  };
  const onUnsubscribe = async () => {
    setLoadingEmailRequest(true);
    const payload = {
      eventId: Number(id),
      email,
      profile: locale,
    };

    try {
      await unsubscribeTwsEvent(payload);
      setLoadingEmailRequest(false);
      setShowThankYou(true);
      setThankYouType('eventUnsuscribed');
    } catch (rqError) {
      console.error(rqError);
      let errorMessage = 'KO: Unexpected Error';
      if (rqError?.data?.errors?.length > 0) {
        errorMessage = rqError?.data?.errors[0].message || 'KO: Unexpected Error';
      }
      setError(errorMessage);
      setLoadingEmailRequest(false);
    }
  };
  const isLoading = loadingEmailRequest || loading;
  const twsTermsConditionsLabel = t('generico', 'events.tws.tc');
  const twsTermsConditionsLabelHasValue = twsTermsConditionsLabel && twsTermsConditionsLabel !== 'generico.events.tws.tc';
  return (
    <Modal
      title=""
      visible={modalTwsVisible}
      footer={null}
      onCancel={!isLoading ? () => setModalTwsVisible(false) : () => true}
      wrapClassName={styles.modalWrapper}
      destroyOnClose={true}
      closeIcon={<CloseModalSVG />}
      maskClosable={!isLoading}
      keyboard={!isLoading}
      closable={!isLoading}
    >
      <Spin spinning={isLoading}>
        <div className={styles.modalContent}>
          <div className={`${styles.content} ${showThankYou ? styles.thankYouContent : ''}`}>
            {type === 'subscribe' &&
              <>
                {showThankYou && <ThankYouMessage type={thankYouType} className={styles.thankYouMessage} />}
                {!IS_NNORMAL && showThankYou && thankYouType !== 'eventSuscribedFull' &&
                  <>
                    <p className={styles.shareText}>
                      {t('generico', 'modal.events.tws.share')}
                    </p>
                    <div className={styles.shareDiv}>
                      <a href={`https://web.whatsapp.com/send?text=https%3A%2F%2Fwww.camper.com%2F${locale}%2Fcontent%2Fnews%23${id}`} target='_blank' rel="noreferrer">
                        <img src='/assets-new/img/share/whatsapp.png' alt='whatsapp share' width={28} height={28} />
                      </a>
                      <a href={`mailto:?subject=sharing link\n&body=I'm going to this event: https://www.camper.com/${locale}/content/news#${id}`} target='_blank' rel="noreferrer">
                        <img src='/assets-new/img/share/email.png' alt='email share' width={28} height={28} />
                      </a>
                    </div>
                  </>
                }
                {!showThankYou &&
                <>
                  <img
                    src={IS_NNORMAL ? '/assets-new/logo-nnormal.svg' : '/assets-new/img/tws/tws_events.svg'}
                    alt={'Members Only Logo'}
                    width={IS_NNORMAL ? 200 : 80}
                    height={80}
                  />
                  <p className={styles.title}>{t('generico', isNewUser ? 'modal.events.tws.title.not.member' : 'modal.evevts.tws.title', 'Members Only')}</p>
                  <p
                    className={styles.subtitle}
                    dangerouslySetInnerHTML={{
                      __html: t('generico', isNewUser ? 'modal.events.tws.subtitle.not.member' : 'modal.events.tws.subtitle', 'To buy this exclusive option, please enter your email below'),
                    }}
                  />
                  <Form
                    form={emailForm}
                    layout="vertical"
                    name="emailForm"
                    onFinish={onFinish}
                    requiredMark='optional'
                    scrollToFirstError
                    className={styles.emailForm}
                    initialValues={{ preffix: market }}
                  >
                    {isNewUser &&
                      <Form.Item name="name">
                        <Input placeholder={t('compra.formulario', 'nombre')} autoComplete="name" maxLength={20}/>
                      </Form.Item>
                    }
                    <Form.Item
                      name="email"
                      rules={
                        [
                          {
                            required: true,
                            message: t('validation', 'required.email', 'Please input your email'),
                          },
                          {
                            type: 'string',
                            pattern: /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i,
                            message: '',
                          },
                        ]
                      }
                      required
                    >
                      <Input placeholder={t('generico', 'input.email.placeholder', 'Enter your email')} type="email" autoComplete="false"/>
                    </Form.Item>
                    {false && // por ahora deciden no pedirlo
                      <Form.Item
                        name="telephone"
                        label={t('generico', 'input.fecha.telefono')}
                        className={styles.formPhone}
                        rules={
                          [
                            {
                              required: false,
                            },
                          ]
                        }
                      >
                        <div className={styles.phoneWrapper}>
                          <PhoneInput
                            info={profileData}
                            placeholder={t('generico', 'input.fecha.telefono', 'Phone')}
                            rules={validate('telephone')}
                            className={styles.newsletterPhone}
                            withFloatLabel={false}
                          />
                        </div>
                      </Form.Item>
                    }

                    <div className={styles.termsAndConditionsDiv}>
                      {isNewUser ?
                        <Form.Item>
                          <div className={styles.privacyWrapper}>
                            <p
                              className={styles.infoLink}
                              onClick={() => setDataModalVisible(true)}
                            >
                              {t('generico', !IS_NNORMAL ? 'camper.newsletter.proteccion.datos' : 'newsletter.proteccion.datos', 'Data protection information')}
                            </p>
                          </div>
                        </Form.Item> : null
                      }
                      {isNewUser &&
                        <Form.Item name="privacy" valuePropName="checked" rules={validate('privacyPolicy')}>
                          <Checkbox
                            tabIndex="27"
                            className={market !== 'TR' ? styles.privacyCheckbox : `${styles.privacyCheckbox} ${styles.withMargin}`}
                          >
                            <span className={styles.privacyAgreement}>
                              {t('compra.formulario', 'acepto.las')}&nbsp;
                              <a href={profileData.urlPrivacyPolicy} target="_blank" rel="noreferrer">{t('generico', 'privacy.conditions', 'privacy conditions')}</a>&nbsp;
                              {t('compra.formulario', 'become.member')}
                              {
                                market === 'TR' &&
                                <span>
                                  <br/>
                                  {t('compra.formulario', 'informacion.comercial.tr')}
                                </span>
                              }
                            </span>
                          </Checkbox>
                        </Form.Item>
                      }
                      <Form.Item name="suscribe-tws" valuePropName="checked" rules={validate('privacyPolicy')}>
                        <Checkbox
                          className={styles.privacyCheckbox}
                        >
                          <a href={currentTwsConditionsUrl} target='_blank' rel="noreferrer">
                            <span className={styles.privacyAgreement} dangerouslySetInnerHTML={{ __html: t('generico', 'accept.suscribe.tws.checkbox') }}>
                            </span>
                          </a>
                        </Checkbox>
                      </Form.Item>
                      {twsTermsConditionsLabelHasValue &&
                        <div className={styles.legalText} dangerouslySetInnerHTML={{ __html: t('generico', 'events.tws.tc') }} />
                      }
                    </div>

                    {
                      error &&
                        <span className="error">{error}</span>
                    }

                    <Form.Item className={styles.submitItem}>
                      <Button
                        type="default"
                        htmlType="submit"
                        className={styles.submitBtn}
                        block
                        size="large"
                      >
                        {t('generico', 'tws.subscribe', 'Subscribe')}
                      </Button>
                    </Form.Item>

                  </Form>
                </>
                }
              </>
            }
            {type === 'unsubscribe' &&
              <>
                {showThankYou && <ThankYouMessage type={thankYouType} className={styles.thankYouMessage} />}
                {!showThankYou &&
                  <>
                    <div className={styles.svgSad}>
                      {IS_NNORMAL ?
                        <img
                          src={'/assets-new/logo-nnormal.svg'}
                          alt={'Nnormal Logo'}
                          width={200}
                          height={80}
                        /> :
                        <SadFaceSVG width={50} height={50} />
                      }
                    </div>
                    <div
                      className={`${styles.subtitle} ${styles.unsubscribe}`}
                      dangerouslySetInnerHTML={{
                        __html: t('generico', 'modal.events.tws.unsubscribe.confirm'),
                      }}
                    />
                    <p className={`${styles.subtitle} ${styles.unsubscribe} ${styles.subtext}`}>{t('generico', 'modal.events.tws.unsubscribe.confirm.text')}</p>
                    <Button
                      type="default"
                      className={styles.submitBtn}
                      block
                      size="large"
                      onClick={onUnsubscribe}
                    >
                      {t('generico', 'tws.unsubscribe', 'Unsubscribe')}
                    </Button>
                  </>
                }
              </>
            }
          </div>
        </div>
      </Spin>
      <ProtectionDataModal
        visible={dataModalVisible}
        onCancel={() => setDataModalVisible(false)}
        origin={'newsletter'}
      />
    </Modal>
  );
};

EventsTwsModal.defaultProps = {
  loading: false,
  modalTwsVisible: false,
  setModalTwsVisible: () => true,
  onFinishOk: () => true,
  id: '1',
  type: 'subscribe',
  email: '',
};

EventsTwsModal.propTypes = {
  loading: bool,
  modalTwsVisible: bool,
  setModalTwsVisible: func,
  onFinishOk: func,
  id: string,
  type: string,
  email: string,
};

export default EventsTwsModal;
